import { AddDiscountType, DiscountType } from "@jobintrans/base-ui.types.api"
import { APIService } from "./APIService"

const addDiscount = (body: AddDiscountType) =>
  APIService.post<null, DiscountType>(`/admin/tools/discounts`, body)

export const AdminToolsService = {
  addDiscount,
}
